module.exports = __webpack_public_path__ + "static/media/event_details.fa2c1d54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event_details.png
// module id = 871
// module chunks = 0